<div class="client-dashboard">
  <app-nowaccount-shell>
    <div class="nav-tiles">
      <ng-container *ngIf="loading">
        <ng-container *ngFor="let item of [0, 1, 2, 3]; let i = index">
          <app-shimmer-loader class="nav-shimmer" radius="normal-radius"></app-shimmer-loader>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!loading">
        <ng-container *ngFor="let navTile of navTiles">
          <app-nav-tile [headerText]="navTile.title" [routerHref]="navTile.routerHref"
            [alert]="navTile.alert"></app-nav-tile>
        </ng-container>
      </ng-container>
      <!-- <app-account-info></app-account-info> -->
    </div>

    <div *ngIf="loading" class="grid-shimmers">
      <ng-container *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7, 8]; let i = index">
        <app-shimmer-loader class="grid-shimmer" radius="no-radius" style="display: block"></app-shimmer-loader>
      </ng-container>
    </div>
    <ng-container *ngIf="!loading">
      <app-dashboard-grid 
        [items]="gridTiles" 
        (dialogSelectEvent)="dialogSelectEventListener($event)"
        (initializeDialogDataEvent)="initializeDialogDataEventListener($event)"
        [dashboardType]="'Client'"
        style="width: 100%;"
      ></app-dashboard-grid>
    </ng-container>

    <app-dashboard-grid-dialog 
      [dialogSelectedItem]="dialogSelectedItem" 
      [isClient]="true" 
      [isInternal]="false"
      (changeDialogEvent)="dialogChangeEventListener($event)"
    ></app-dashboard-grid-dialog>
  </app-nowaccount-shell>
</div>